import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import Sites from "../ui/sites/Sites";
import SitesList from "../ui/sites/SitesList";
import SiteAddEdit from "../ui/sites/SiteAddEdit";
import SiteDetails from "../ui/sites/SiteDetails";

const SitesRoutes = (
  <Route
    path={AppSections.SITES}
    element={
      <ProtectedRoute>
        <Sites />
      </ProtectedRoute>
    }
  >
    <Route path="/sites/" element={<SitesList />} />
    <Route path="create" element={<SiteAddEdit />} />
    <Route path=":id/view" element={<SiteDetails />} />
    <Route path=":id/edit" element={<SiteAddEdit />} />
  </Route>
);

export default SitesRoutes;
